import { render, staticRenderFns } from "./SlideFadeTransition.vue?vue&type=template&id=6f4c71d2&"
import script from "./SlideFadeTransition.vue?vue&type=script&lang=js&"
export * from "./SlideFadeTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports